<template>
    <layout 
      title="Jira" 
      :isLoading="isLoading"
      subtitle="Associações de Perfis Jira"
      titleIcon="rocket"
    >
      <table-default>
        <template #default>
          <div class="dual-combo-container">
            <!-- Combos de Perfis -->
            <div class="combo">
              <h4>Perfis Disponíveis</h4>
              <select multiple v-model="selectedFromAvailable">
                <option v-for="item in availableProfiles" :key="item.id" :value="item">
                  {{ item.name }} (ID: {{ item.id }})
                </option>
              </select>
            </div>
  
            <div class="buttons">
              <button @click="moveToSelected" :disabled="selectedFromAvailable.length === 0">→</button>
              <button @click="moveToAvailable" :disabled="selectedFromSelected.length === 0">←</button>
            </div>
  
            <div class="combo">
              <h4>Perfis Associados</h4>
              <select multiple v-model="selectedFromSelected">
                <option v-for="item in selectedProfiles" :key="item.id" :value="item">
                  {{ item.name }}
                </option>
              </select>
            </div>
          </div>
  
          <!-- Opções Exclusivas -->
          <div class="radio-group">
            <h4>Selecione uma Opção Jira</h4>
            <div>
              <label>
                <input type="radio" name="jira-option" :value="{ name: 'Jira Client', id: 1 }" v-model="selectedJiraOption" />
                Jira Client
              </label>
            </div>
            <div>
              <label>
                <input type="radio" name="jira-option" :value="{ name: 'Jira Software', id: 2 }" v-model="selectedJiraOption" />
                Jira Software
              </label>
            </div>
            <div>
              <label>
                <input type="radio" name="jira-option" :value="{ name: 'Jira Management', id: 3 }" v-model="selectedJiraOption" />
                Jira Management
              </label>
            </div>
  
            <!-- Botões -->
            <div class="action-button">
              <button :disabled="!canAssociateProfiles" @click="associateProfiles">
                Associar Perfil
              </button>
            </div>
  
            <div class="action-button">
              <button :disabled="!canDissociateProfiles" @click="dissociateProfiles">
                Desassociar Perfil
              </button>
            </div>
  
            <div class="action-button">
              <button @click="openModal">
                Visualizar Perfis Jira
              </button>
            </div>
  
            <!-- Modal de Perfis com Paginação -->
            <div v-if="showModal" class="modal-overlay">
              <div class="modal-content">
                <h3>Perfis Associados ao Jira</h3>
  
                <ul>
                  <li v-for="profile in paginatedProfiles" :key="profile.id">
                    ID: {{ profile.id }}, Grupo: {{ profile.groupId }}
                  </li>
                </ul>
  
                <div class="pagination-controls">
                  <button @click="prevPage" :disabled="currentPage === 1">Anterior</button>
                  <span>Página {{ currentPage }} de {{ totalPages }}</span>
                  <button @click="nextPage" :disabled="currentPage === totalPages">Próxima</button>
                </div>
  
                <button @click="closeModal">Fechar</button>
              </div>
            </div>
          </div>
        </template>
      </table-default>
    </layout>
  </template>
  
  <script>
  import { Component, Vue } from 'vue-property-decorator';
  import TableDefault from '@/components/Layout/TableDefault.vue';
  import services from '@/http';
  
  @Component({
    components: {
      TableDefault,
    },
  })
  export default class AddPerfil extends Vue {
    showModal = false;
    availableProfiles = [];
    selectedProfiles = [];
    currentProfilesAssociate = [];
    getProfiles = [];
    selectedFromAvailable = [];
    selectedFromSelected = [];
    selectedJiraOption = null;
    isLoading = false;
  
    currentPage = 1;
    pageSize = 5;
  
    mounted() {
      this.list();
    }
  
    // Computed para paginação
    get paginatedProfiles() {
      const start = (this.currentPage - 1) * this.pageSize;
      const end = start + this.pageSize;
      return this.currentProfilesAssociate.slice(start, end);
    }
  
    get totalPages() {
      return Math.ceil(this.currentProfilesAssociate.length / this.pageSize) || 1;
    }
  
    get canAssociateProfiles() {
      return this.selectedFromSelected.length > 0 && this.selectedJiraOption !== null;
    }
  
    get canDissociateProfiles() {
      return this.selectedFromSelected.length > 0 && this.selectedJiraOption !== null;
    }
  
    list() {
      this.isLoading = true;
      services.profile.list()
        .then((res) => {
          this.availableProfiles = res.data.data.map(profile => ({
            id: profile.PerfilID,
            name: profile.Titulo,
          }));
        })
        .catch((err) => {
          this.$root.flashError(err);
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
  
    async openModal() {
      try {
        if (!this.selectedJiraOption) {
          this.$root.flashError("Por favor, selecione uma opção Jira antes de visualizar os perfis.");
          return;
        }
        this.isLoading = true;
        await this.listPerfisJira();
        this.currentPage = 1;
        this.showModal = true;
      } catch (err) {
        console.error('Erro ao carregar perfis:', err);
        this.$root.flashError(err.body?.message || 'Erro ao carregar os perfis.');
      } finally {
        this.isLoading = false;
      }
    }
  
    closeModal() {
      this.showModal = false;
      this.currentPage = 1;
    }
  
    async listPerfisJira() {
      try {
        const selectedId = typeof this.selectedJiraOption === 'object' ? this.selectedJiraOption.id : this.selectedJiraOption;
        if (!selectedId) {
          this.$root.flashError("Nenhuma opção Jira válida foi selecionada.");
          return;
        }
  
        const res = await this.$http.get(`v1/movida/jira/show/${selectedId}`);
        if (res.body && Array.isArray(res.body.data)) {
          this.currentProfilesAssociate = res.body.data.map(profile => ({
            id: profile.PerfilId,
            groupId: profile.GrupoId,
          }));
          this.getProfiles = res.body.data.map(profile => ({
            perfilId: profile.PerfilId
          }));
        } else {
          this.$root.flashError('Resposta inválida do servidor.');
        }
      } catch (err) {
        this.$root.flashError(err.body?.message || 'Erro ao buscar perfis.');
      }
    }
  
    moveToSelected() {
      const items = [...this.selectedFromAvailable];
      this.selectedProfiles.push(...items);
      this.availableProfiles = this.availableProfiles.filter(item => !items.includes(item));
      this.selectedFromSelected = [...this.selectedProfiles];
      this.selectedFromAvailable = [];
    }
  
    moveToAvailable() {
      const items = [...this.selectedFromSelected];
      this.availableProfiles.push(...items);
      this.selectedProfiles = this.selectedProfiles.filter(item => !items.includes(item));
      this.selectedFromSelected = [];
    }
  
    async associateProfiles() {
      try {
        this.isLoading = true;
        const selectedId = typeof this.selectedJiraOption === 'object' ? this.selectedJiraOption.id : this.selectedJiraOption;
        await this.listPerfisJira();
  
        if (!this.selectedProfiles.length) {
          throw new Error('Nenhum perfil selecionado.');
        }
  
        const payload = {
          PerfilId: this.selectedProfiles[0].id,
          GrupoId: selectedId,
        };
  
        await this.$http.post(`v1/movida/jira/add`, payload);
        this.$root.flashSuccess('Perfil associado com sucesso!');
      } catch (err) {
        console.error('Erro ao associar perfis:', err);
        this.$root.flashError(err.body?.message || 'Erro ao associar perfis.');
      } finally {
        this.isLoading = false;
      }
    }
  
    async dissociateProfiles() {
        try {
            this.isLoading = true;
            await this.listPerfisJira();

            const selectedId = typeof this.selectedJiraOption === 'object' ? this.selectedJiraOption.id : this.selectedJiraOption;

            if (!this.selectedProfiles.length) {
                throw new Error('Nenhum perfil selecionado para dissociar.');
            }

            for (const selected of this.selectedProfiles) {
                const perfilId = selected.id;

                await this.$http.delete(`v1/movida/jira/perfilId/${perfilId}/grupoId/${selectedId}`);
            }

            this.$root.flashSuccess('Perfis dissociados com sucesso!');
        } catch (err) {
            console.error('Erro ao dissociar perfis:', err);
            this.$root.flashError(err.body?.message || 'Erro ao dissociar perfis.');
        } finally {
            this.isLoading = false;
        }
    }


    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
      }
    }
  
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
      }
    }
  }
  </script>
  
  <style scoped>
  .modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
  }
  
  .modal-content {
    background-color: white;
    padding: 20px;
    border-radius: 8px;
    width: 400px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    text-align: center;
  }
  
  .modal-content h3 {
    margin-bottom: 20px;
  }
  
  .modal-content button {
    margin-top: 20px;
    padding: 10px 15px;
    background-color: #f47920;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
  }
  
  .modal-content button:hover {
    background-color: #d4671a;
  }
  
  .pagination-controls {
    margin-top: 15px;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 15px;
  }
  
  .pagination-controls button {
    padding: 8px 12px;
    background-color: #f47920;
    border: none;
    border-radius: 4px;
    color: white;
    cursor: pointer;
    font-weight: bold;
  }
  
  .pagination-controls button:disabled {
    background-color: #ccc;
    cursor: not-allowed;
  }
  
  .dual-combo-container {
    display: flex;
    align-items: center;
    justify-content: space-around;
    gap: 20px;
    margin-top: 20px;
  }
  
  .combo {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  
  .radio-group {
    margin-top: 20px;
    text-align: center;
  }
  
  .radio-group h4 {
    margin-bottom: 10px;
  }
  
  .radio-group label {
    margin-right: 15px;
  }
  
  select {
    width: 400px;
    height: 300px;
    border: 1px solid #ccc;
    border-radius: 4px;
    padding: 5px;
    font-size: 16px;
  }
  
  .buttons {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
  
  button {
    padding: 10px;
    font-size: 16px;
    border: none;
    border-radius: 4px;
    background-color: #F47920;
    color: white;
    cursor: pointer;
  }
  
  button:disabled {
    background-color: #ccc;
    cursor: not-allowed;
  }
  
  .action-button {
    display: flex;
    justify-content: flex-end;
    margin-top: 20px;
  }
  </style>
  